import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-identification-success',
  templateUrl: './identification-success.component.html'
})
export class IdentificationSuccessComponent implements OnInit {

  altEmail: string;
  private altEmailParam = 'altEmail';

  constructor(
    public translate: TranslateService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.altEmail = params[this.altEmailParam];
    });
    // console.log(this.altEmail);
  }

}
